<template>
    <div>
    <div class="list-group-item log-item-new" :class="{ 'log-item--queued': isQueued }">
        <div class="row">
            <div class="col-md-6">
                <span class="contact-date" v-if="!editing">{{ entry.contacted_at ? formatDate(entry.contacted_at) : '-' }}</span>
                <template v-if="editing">
                    <datepicker
                        :format="'yyyy-MM-dd'"
                        v-model="editContactedDate"
                        language="sv"
                        input-class="form-control"
                        :monday-first="true"
                        :disabled="disabledDates">
                    </datepicker>
                    <input type="time" style="width:110px; margin-top:6px;" class="form-control" v-model="editContactedTime" @click.stop />
                    <div class="text-danger" v-if="getError('contacted_at')" style="margin-top:6px;">{{ getError('contacted_at')[0] }}</div>
                </template>
            </div>
            <div class="col-md-8">
                <span v-if="entry.admin">{{ entry.admin.name }}</span>
                <span v-if="entry.type === 'inkommande-svar' && clinic.name_person">{{ clinic.name_person }}</span>
            </div>
            <div class="col-md-7">
                <span style="font-weight:400;">{{ entry.type_label }}</span>
                <span class="badge badge-light-grey" v-if="entry.contact_by_email == 1">Mejl</span>
                <span class="badge badge-light-grey" v-if="entry.contact_by_sms == 1">SMS</span>
                <!-- <span class="badge badge-light-grey" v-if="isQueued">Köad</span> -->
            </div>
            <div :class="{ 'col-md-24' : isQueued || isEditableActivity || isScrapeApplication, 'col-md-29' : !isQueued && !isEditableActivity && !isScrapeApplication }">

                <div v-if="entry.contact_by_email == 1" style="display:flex; justify-content:space-between; margin-bottom:8px;">
                    <span>Ämne: {{ entry.email_subject }}</span>
                    <a
                        v-if="!editing"
                        style="loat:right; color:#666; font-weight: 400; cursor: pointer;"
                        @click="openEmailModal">
                        Visa hela mejlet
                    </a>
                </div>

                <template v-if="editing">
                    <VueTrix v-if="entry.contact_by_email == 1" :inputId="'edit_email_' + entry.id" v-model="editEmailMessage" @click.native.stop />
                    <textarea v-if="entry.contact_by_sms == 1" class="form-control" style="height:120px;" v-model="editSmsMessage" @click.stop></textarea>
                    <VueTrix v-if="!entry.is_message" :inputId="'edit_comment_' + entry.id" v-model="editComment" @click.native.stop />
                </template>
                <template v-else>
                    <div v-if="entry.contact_by_email == 1" class="logg-message" :class="message_type(entry.type,entry.contact_by_email,entry.contact_by_sms)" v-html="entry.email_message"></div>
                    <div style="width:100%; height: 20px;" v-if="entry.contact_by_sms && entry.contact_by_email"></div>
                    <div v-if="entry.contact_by_sms == 1" class="logg-message" style="white-space: pre-wrap;" :class="message_type(entry.type,entry.contact_by_email,entry.contact_by_sms)" v-html="entry.sms_message"></div>
                </template>
                <div v-if="entry.option_label" style="font-weight: 400;">Orsak: {{ entry.option_label }}</div>
                <div v-if="!editing || entry.is_message" v-html="entry.comment"></div>

            </div>
            <div class="col-md-5" v-if="isQueued || isEditableActivity">
                <button
                    class="btn btn-xs btn-default"
                    style="float:right; margin-left:8px; margin-bottom: 6px;"
                    :disabled="patcher.submitted"
                    @click="editing ? saveEdit() : startEdit()">
                    {{ editing ? 'Spara' : 'Ändra' }}
                </button>
                <button
                    v-if="editing"
                    class="btn btn-xs btn-secondary"
                    style="float:right; margin-right:6px;"
                    @click="cancelEdit">
                    Avbryt
                </button>
                <delete-button v-else style="float:right;" :clinic="clinic" :entry="entry" @deleted="$emit('deleted', $event)"></delete-button>
            </div>
            <div class="col-md-5" v-if="isScrapeApplication">
                <button
                    class="btn btn-xs btn-info"
                    style="float:right;"
                    @click="showScrapeModal = true">
                    Visa anmälan
                </button>
            </div>

        </div>

    </div>

    <div class="modal fade" tabindex="-1" role="dialog" :id="'emailModal-' + entry.id">
        <div class="modal-dialog modal-lg" style="max-width: 900px;" role="document">
            <div class="modal-content"  style="padding: 20px; border-radius: 12px;">
                <iframe
                    :src="'/clinics/' + clinic.id + '/contactLog/' + entry.id + '/emailHtml'"
                    style="width:100%; height:600px; border:none;">
                </iframe>
            </div>
        </div>
    </div>

    <scrape-application-modal v-if="showScrapeModal" :scrape-object="entry.scrape_object" @close="showScrapeModal = false" />

    </div>
</template>

<script>

import patcher from '../../../../shared/mixins/patcher'
import VueTrix from 'vue-trix'
import DeleteButton from './log-row-delete-button.vue'
import ScrapeApplicationModal from './scrape-application-modal.vue'

export default {

    mixins: [
        patcher
    ],

    components: {
        DeleteButton,
        VueTrix,
        ScrapeApplicationModal
    },

    props: {
        clinic: {
            required: true
        },
        entry: {
            required: true
        }
    },

    data () {
        return {
            folded: false,
            editing: false,
            editSmsMessage: '',
            editEmailMessage: '',
            editComment: '',
            editContactedDate: null,
            editContactedTime: '',
            showScrapeModal: false
        }
    },

    created () {
        moment.locale('sv')
    },

    computed: {
        isQueued () {
            return !!this.entry.job_id &&
                this.entry.contacted_at &&
                moment(this.entry.contacted_at).isAfter(moment())
        },
        isEditableActivity () {
            return !this.entry.is_message &&
                this.entry.is_selectable &&
                moment(this.entry.created_at).isAfter(moment().subtract(7, 'days'))
        },
        isScrapeApplication () {
            return this.entry.type === 'prospect-skapades' &&
                this.entry.comment === 'Intresseanmälan' &&
                !!this.entry.scrape_object
        },
        patcherUrl () {
            return '/clinics/' + this.clinic.id + '/contactLog/' + this.entry.id
        },
        patcherData () {
            const contacted_at = moment(this.editContactedDate).format('YYYY-MM-DD') + ' ' + this.editContactedTime + moment().format(':ss')

            if (this.entry.is_message) {
                return {
                    sms_message: this.editSmsMessage,
                    email_message: this.editEmailMessage,
                    contacted_at
                }
            }

            return {
                comment: this.editComment,
                contacted_at
            }
        },
        disabledDates () {
            if (!this.entry.is_message) {
                return {}
            }

            return {
                to: moment().subtract(1, 'day').endOf('day').toDate()
            }
        }
    },
    methods: {
        startEdit () {
            this.editSmsMessage = this.entry.sms_message
            this.editEmailMessage = this.entry.email_message
            this.editComment = this.entry.comment
            this.editContactedDate = new Date(this.entry.contacted_at)
            this.editContactedTime = moment(this.entry.contacted_at).format('HH:mm')
            this.editing = true
            this.folded = true
        },

        saveEdit () {
            this.clearError('contacted_at')
            this.patcherPatch()
        },

        cancelEdit () {
            this.editing = false
        },

        patcherSuccess (data) {
            this.editing = false
            this.$emit('updated', data)
            bus.$emit('notify', 'Kontaktloggen uppdaterades.')
        },

        openEmailModal () {
            $('#emailModal-' + this.entry.id).modal('show')
        },
        formatDate(date) {
            const m = moment(date)
            const now = moment()
            const time = m.format('HH:mm')

            if (m.isSame(moment(), 'day')) {
            return `Idag ${time}`
            }

            if (m.isSame(moment().subtract(1, 'day'), 'day')) {
            return `Igår ${time}`
            }

            if (m.isSame(moment().add(1, 'day'), 'day')) {
            return `Imorgon ${time}`
            }

            const dateFormat = m.isSame(now, 'year') ? 'dddd D MMM' : 'dddd D MMM YYYY'

            return `${m.format(dateFormat)} ${time}`

        },
        message_type (status, email, sms) {
            if (status == 'inkommande-svar') {
                return 'in'
            } else if (status != 'inkommande-svar' && (email == 1 || sms == 1)) {
                return 'out'
            }
            return ''
        }
    }

}
</script>
